<template>
  <div class="jumbotron">
    <div class="row top-row-padding">
      <h4>Company Description</h4>
    </div>
    <div class="row form-row-padding">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom d-inline-block">What you do<span v-if="!getCompanyInfo" class="red-text">*</span></p>
      </div>
      <div class="col-md-9">
        <textarea v-model="companyInfo"
                  class="form-control form-control-lg"
                  rows="5"
                  placeholder="Services you provide, Awards, Certifications, etc."
                  v-bind:class="{'is-invalid': companyInfoInvalid}"></textarea>
        <div class="invalid-feedback">Please enter a description of what you do.</div>
      </div>
    </div>
    <div class="row form-row-padding">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom d-inline-block">Who you are</p>
      </div>
      <div class="col-md-9">
        <textarea v-model="companyInfoTwo"
                  class="form-control form-control-lg"
                  placeholder="Information about company founder, mission statement, corporate goals, etc."
                  rows="5"></textarea>
      </div>
    </div>
    <div class="row homapt-padding-bottom">
      <div class="col-lg-6 offset-lg-3">
        <button v-if="complete" v-on:click="save" class="btn btn-primary">Save</button>
        <button v-else v-on:click="save" class="btn btn-primary">Save & Continue</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import router from '../../../../../router/index.js'

export default {
  created () {
    this.complete = this.profileIsComplete.profileComplete
  },
  data () {
    return {
      companyInfoInvalid: false,
      formInvalid: false,
      complete: false,
      showDismissibleAlert: false
    }
  },
  computed: {
    ...mapGetters('business', [
      'getCompanyInfo',
      'getCompanyInfoTwo',
      'profileIsComplete'
    ]),
    companyInfo: {
      get () {
        return this.getCompanyInfo
      },
      set (value) {
        this.updateCompanyInfo(value)
      }
    },
    companyInfoTwo: {
      get () {
        return this.getCompanyInfoTwo
      },
      set (value) {
        this.updateCompanyInfoTwo(value)
      }
    }
  },
  methods: {
    ...mapActions('business', [
      'syncData'
    ]),
    ...mapMutations('business', [
      'updateCompanyInfo',
      'updateCompanyInfoTwo'
    ]),
    async save () {
      this.validate()
      if (this.formInvalid === false) {
        this.syncData()
        this.showDismissibleAlert = true
        if (!this.complete) {
          router.replace('/profile/business/details/preferences')
        }
      }
    },
    validate () {
      this.formInvalid = false

      if (!this.getCompanyInfo) {
        this.companyInfoInvalid = true
        this.formInvalid = true
      } else {
        this.companyInfoInvalid = false
      }
    }
  }
}
</script>

<style scoped>
textarea {
  width: 100%;
  font-size: 16px;
}

.form-row-padding {
  padding-bottom: 2rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.homapt-padding-bottom {
  padding-bottom: 2rem;
}

.top-row-padding {
  padding-bottom: 1rem;
}

.grayout {
  background-color: gray !important;
  color: black !important;
  cursor: unset !important;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.btn {
  margin-top: 0px !important;
}

.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/details/details/About.vue